import { CareType, CostAssignmentType, CostBearerType } from '@dokucoach/invoicing-types';
import * as Yup from 'yup';
import { IAddressNullable, IAddressNullableInput, IAddressNullableSchema } from '../../forms';

export type IInvoice = {
  id: string;
  nursingHomeId: string;
  residentId: string;
  billedCareType: CareType;
  isDraft: boolean;
  voucherNumber: string;
  voucherDate: Date;
  servicePeriodStart: Date;
  servicePeriodEnd: Date;
  privateCostBearerId: string;
  privateCostBearerAddress: IAddressNullable;
  insuranceCostBearerId: string;
  insuranceCostBearerAddress: IAddressNullable;
  welfareCostBearerId: string;
  welfareCostBearerAddress: IAddressNullable;
  remark: string | null;
  version: number;
};

export type IInvoiceUpdateBase = {
  voucherNumber?: string;
  voucherDate?: Date;
  servicePeriodStart?: Date;
  servicePeriodEnd?: Date;
  remark?: string | null;
};

export const IInvoiceUpdateBaseSchema = Yup.object({
  voucherNumber: Yup.string().optional(),
  voucherDate: Yup.date().optional(),
  servicePeriodStart: Yup.date().optional(),
  servicePeriodEnd: Yup.date()
    .min(Yup.ref('servicePeriodStart'), 'End date must be after start date')
    .optional(),
  remark: Yup.string().nullable().optional(),
});

export type IInvoiceUpdateCostBearers = {
  /** if set to null, the resident will become the new private cost bearer */
  supervisorId?: string | null;
  insuranceId?: string;
  welfareOfficeId?: string;
  privateCostBearerAddress?: IAddressNullableInput | null;
  insuranceCostBearerAddress?: IAddressNullableInput | null;
  welfareCostBearerAddress?: IAddressNullableInput | null;
};

export const IInvoiceUpdateCostBearersSchema = Yup.object({
  supervisorId: Yup.string().nullable().optional(),
  insuranceId: Yup.string().optional(),
  welfareOfficeId: Yup.string().optional(),
  privateCostBearerAddress: IAddressNullableSchema,
  insuranceCostBearerAddress: IAddressNullableSchema,
  welfareCostBearerAddress: IAddressNullableSchema,
});

export type ISummarizedInvoiceAssignments = {
  id: string;
  costAssignmentType: CostAssignmentType;
  costBearerType: CostBearerType;
  label: string;
  amount: number;
  amountPrivatePayer?: number | null;
  amountInsurance?: number | null;
};

export type ISummarizedInvoiceCostAssignments = {
  costBearerType: CostBearerType;
  totalAmount: number;
  assignments: ISummarizedInvoiceAssignments[];
};

export type ISummarizedInvoiceCostAssignmentsToBePaid = {
  costBearerType: CostBearerType;
  amountToBePaid: number;
};
